<input type="text" [readOnly]="readMode" class="form-control" [(ngModel)]="searchState"
    (input)="SearchState()" (blur)="NotifyParent()"
    placeholder="Search..." [attr.list]="'state'+this.idx">

<datalist [id]="'state'+this.idx">
    @for (x of states; track $index) {
        <option>
            {{ x.id }}. {{ x.descr }}
        </option>
    }
</datalist>